import makeActionCreator from '../../utils/actionCreator';
import { httpActionTypes } from './actionTypes';

export const httpRequestMade = makeActionCreator<[string]>(
  httpActionTypes.REQUEST_MADE,
  'request',
);

export const httpRequestSuccess = makeActionCreator<[string]>(
  httpActionTypes.REQUEST_SUCCESS,
  'request',
);

export const httpRequestError = makeActionCreator<[string, Error | boolean]>(
  httpActionTypes.REQUEST_ERROR,
  'request',
  'error',
);

export const resetRequestError = makeActionCreator(
  httpActionTypes.REQUEST_RESET,
);
